import { Stack, Typography, Divider, Fade, Tab } from "@mui/material";
import { ShPaper } from "shared/SharedStyles/ShSurfaces";
import { useState } from "react";
import { CandidateSummaryProps } from "../ApplicantCandidateAiSummaryModels";
import { ShTabs } from "shared/SharedStyles/ShNavigation";
import { ShGreen } from "shared/SharedStyles/styleConstants";

const formatExperienceDuration = (yearsDecimal: number) => {
    const totalMonths = Math.round(yearsDecimal * 12);
    const years = Math.floor(totalMonths / 12);
    const remainingMonths = totalMonths % 12;
    return years > 0
        ? `${years} year${years !== 1 ? "s" : ""}${remainingMonths ? ` ${remainingMonths} month${remainingMonths !== 1 ? "s" : ""}` : ""}`
        : `${remainingMonths} month${remainingMonths !== 1 ? "s" : ""}`;
};

export const ExperienceSection: React.FC<CandidateSummaryProps> = ({ candidate }) => {
    const [selected, setSelected] = useState(0);

    if (!candidate?.previous_experience?.length) return null;

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {
        setSelected(newValue);
    };

    return (
        <Fade in={true} timeout={800}>
            <Stack spacing={2}>
                <Typography fontSize={18}>EXPERIENCES</Typography>
                <Divider flexItem />
                <ShTabs value={selected} onChange={handleChange} variant="scrollable" scrollButtons="auto" highlightVariant="underline">
                    {candidate.previous_experience.map((exp, idx) => (
                        <Tab
                            key={idx}
                            label={`${idx + 1}. ${exp.job_title || `Experience ${idx + 1}`}`}
                            sx={{ minWidth: 120 }}
                        />
                    ))}
                </ShTabs>
                <ShPaper sx={{ p: 2 }} variant="outlined" leftBorderWidth="4px" leftBorderColor={ShGreen}>
                    <Typography variant="subtitle2" gutterBottom>
                        {candidate.previous_experience[selected].job_title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {candidate.previous_experience[selected].employer}
                    </Typography>
                    <Divider sx={{ my: 1 }} />
                    <Typography variant="caption" color="primary">
                        {candidate.previous_experience[selected].duration}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        {formatExperienceDuration(Number(candidate.previous_experience[selected].years))}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        {candidate.previous_experience[selected].description}
                    </Typography>
                </ShPaper>
            </Stack>
        </Fade>
    );
};

export default ExperienceSection;
